export default "__VITE_ASSET__K76rvyM1__"